module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'load-cancelled': _vm.decorated.status_text === 'Cancelled'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.load.id
        }
      }
    }
  }, [_c('p', {
    staticClass: "load-reference"
  }, [_vm._v("\n      " + _vm._s(_vm.decorated.reference_number) + "\n      "), _c('span', {
    staticClass: "load-status pull-right",
    class: _vm.decorated.status_class
  }, [_vm._v(_vm._s(_vm.decorated.status_text))])]), _vm._v(" "), _c('p', {
    staticClass: "load-description"
  }, [_vm._v(_vm._s(_vm.decorated.commodity_and_location))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.loading_date) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.loading_time) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.delivery_date) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Time")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.delivery_time) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Net Weight")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.net_weight) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.rate) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-4"
  }, [_c('p', {
    staticClass: "load-cost"
  }, [_c('strong', [_vm._v("Load Income")]), _c('br'), _vm._v("\n\n        " + _vm._s(_vm.carrierProfitAsMoney) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-4"
  }, [_c('p', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v("Carrier")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.company) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Rego")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.registration) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2 col-xl-1"
  }, [_c('p', [_c('strong', [_vm._v("Configuration")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.decorated.configuration_description) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3 col-xl-2"
  }, [_c('p', [_c('strong', [_vm._v("Weighbridge Details")]), _c('br'), _vm._v(" "), (_vm.haveWeighbridge) ? _c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-load-check"
    },
    on: {
      "click": _vm.setActiveLoad
    }
  }, [_vm._v("\n          View "), _c('i', {
    staticClass: "fa fa-external-link-square"
  })]) : _c('span', [_vm._v("–")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-lg-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.load.notes ? _vm.load.notes : '–') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Dockets")]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dockets ? _vm.dockets : '–')
    }
  })])]), _vm._v(" "), (_vm.$user.isCarrier) ? _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Additional Charges")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.additionalChargesTotalAsMoney))])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-20e8ffdd"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadItem.vue
// module id = 950
// module chunks = 0